
import { defineComponent } from 'vue';
import config from '@/shared/constants/config';

export default defineComponent({
  name: 'TheFooter',

  data() {
    return {
      kabernetLogoUrl: config.BASE_URL + '/img/kabernet-logo-footer-grayscale.svg',
      domain: config.DOMAIN.split('.')[0],
      config: config,
    };
  },
});
